import ReactQuill from 'react-quill-new';

/**
 * These elements show content, but they have no text. The editor formats do
 * not permit them. Data that the backend stored before can contain them.
 * The `br` element is not one of them. Quill writes `br` into each empty line.
 */
const CONTENT_ELEMENTS =
  /<(img|hr|iframe|video|audio|embed|object|svg|canvas)(?=[\s/>])/i;

/**
 * Quill marks an empty line with the block tag of that line. An empty document
 * is thus `<p><br></p>`, `<h1><br></h1>`, `<ul><li><br></li></ul>` or an
 * equivalent. This function removes the tags before it looks for text.
 */
export const isEmptyWysiwygHtml = (
  html: string | undefined | null,
): boolean => {
  if (!html) {
    return true;
  }
  if (CONTENT_ELEMENTS.test(html)) {
    return false;
  }
  return (
    html
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/g, ' ')
      .trim() === ''
  );
};

/**
 * Reads HTML string from `ReactQuill` instance.
 * It returns empty string when wysiwyg is empty.
 */
export const getWysiwygHtml = (reactQuill: ReactQuill) => {
  const editor = reactQuill.getEditor();
  const unprivilegedEditor = reactQuill.makeUnprivilegedEditor(editor);
  const html = unprivilegedEditor.getHTML();
  const trimmedHtml = (typeof html === 'string' ? html : '').trim();
  return isEmptyWysiwygHtml(trimmedHtml) ? '' : trimmedHtml;
};
